import * as React from "react";
import { connect } from "react-redux";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import * as msgs from "../../constants/textConstants";
import * as types from "../../constants/actionTypes";
import { getFirstName, firstNameFirst, getInitials } from "../../helpers/formatting";
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { logUI } from "../../api/andyliticsApi";
import { Typography, Divider } from '../ecosystem';
import { withRouter } from 'react-router-dom';
import Test from "./test";
class MobileActiveUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = { dropdownOpen: false };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ActiveUser.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let { loginStatus, primaryUser, currentMyChartUser,
            currentPharmacyUser, onLogoutClick, mobileView,
            containerClass, dateTimeOffset, bundle, patientPhoto,
            location, isDashboardPage
        } = this.props;
        let greetingText = '';
        let proxyText = '';
        let displayName = '';
        let mainClass = containerClass ? containerClass : '';
        let activeUser = null;
        let showMobileBanner = isDashboardPage ? false : true;

        try {

            if (primaryUser) {

                try {
                    // Stinky poopoo javascript dates!
                    const thisStartDate = new Date();
                    const thisUTCDate = new Date(Date.parse(thisStartDate.toUTCString()) - (dateTimeOffset * 60000));
                    const hour = thisUTCDate.getUTCHours();
                    //const pathname = (typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "");
                    //const onPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
                    //debugger;
                    displayName = getFirstName(primaryUser.displayName);
                    greetingText = hour < 12 ? 'Good morning,' : (hour < 18 ? 'Good afternoon,' : 'Good evening,');
                    if (currentMyChartUser && primaryUser && currentMyChartUser.externalId !== primaryUser.externalId &&
                        currentMyChartUser.myChartId && primaryUser.myChartId && currentMyChartUser.myChartId.toLowerCase() !== primaryUser.myChartId.toLowerCase()) {
                        proxyText = "Viewing " + getFirstName(currentMyChartUser.displayName);
                    }
                }
                catch (EE) {
                    //debugger;
                    throw EE;
                }
            }

            //console.info(`MobileActiveUser mobileView ${mobileView}`, this.props);
            return (<>
                {showMobileBanner && <div className="row teal-banner">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-6 truncate">
                                <Typography
                                    bold
                                    color="$color-primary-c1"
                                    tag="span"
                                    textAlign="left"
                                    type="body-01"
                                >
                                    {`${greetingText} ${displayName}`}
                                </Typography>
                            </div>
                            <div className="col-6 header__greeting--proxy truncate">
                                <Typography
                                    bold
                                    color="$color-primary-c1"
                                    tag="span"
                                    textAlign="right"
                                    type="body-01"
                                >
                                    {proxyText}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>}
            </>
            );
        }
        catch (E) {
            //debugger;
            throw E;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        loginStatus: state.domain.ls,
        dateTimeOffset: state.domain.dto,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MobileActiveUser));